module.exports = __webpack_public_path__ + "img/office-time.ac3c36d6.svg";